import {API_GATEWAY} from '/constants/API_constants.js'

export async function logOut() {
    const response = await fetch(API_GATEWAY + "session/logout", {
        method: "DELETE",
        headers: {
            'Token-Auth' : `${localStorage.branchof_access_token}`
        },
        credentials: "include"
    });

    localStorage.removeItem('branchof_access_token');
    localStorage.removeItem('branchof_access_username');
    window.location = '/login';
    
}

export async function logOutWithTimeOut(timer=3000) {
    const response = await fetch(API_GATEWAY + "session/logout", {
        method: "DELETE",
        headers: {
            'Token-Auth' : `${localStorage.branchof_access_token}`
        },
        credentials: "include"
    });

    localStorage.removeItem('branchof_access_token');
    localStorage.removeItem('branchof_access_username');
    setTimeout(() => {
        window.location = '/login';
    }, timer);

}